import type { RuleEdgeData, RuleEdgeProps } from "../types/edges";
import BaseEdge, { EdgeAddButtonLayer } from "./BaseEdge";

const DecisionFalseEdge = (props: RuleEdgeProps) => {
	const data: RuleEdgeData = {
		...props.data,
		label: "False",
		color: "#DD2C00",
		addButtonBetweenPillAndMarker: true,
	};

	return (
		<>
			<BaseEdge {...props} data={{ ...data, disableAddButton: true }} />
			{!data.disableAddButton && (
				<EdgeAddButtonLayer
					id={props.id}
					source={props.source}
					target={props.target}
					sourceHandleId={props.sourceHandleId}
					sourceX={props.sourceX}
					sourceY={props.sourceY}
					targetX={props.targetX}
					targetY={props.targetY}
					sourcePosition={props.sourcePosition}
					targetPosition={props.targetPosition}
					data={data}
				/>
			)}
		</>
	);
};

export default DecisionFalseEdge;
